module.exports = AMap;


//////////////////
// WEBPACK FOOTER
// external "AMap"
// module id = 108
// module chunks = 1